
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const CTASection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="py-24 lg:py-32 bg-muted-taupe relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-muted-taupe to-taupe/30"></div>
      
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className="relative max-w-5xl mx-auto px-6 lg:px-12 text-center"
      >
        <p className="font-inter text-xs uppercase tracking-widest text-charcoal/60 mb-6">
          Ready to Transform?
        </p>
        
        <h2 className="font-playfair text-4xl lg:text-6xl font-semibold text-charcoal leading-tight mb-8">
          Let's Build Something <br />
          <em className="text-warm-gold">Exceptional</em> Together
        </h2>
        
        <p className="font-inter text-lg text-charcoal/70 max-w-2xl mx-auto mb-12 leading-relaxed">
          Whether you need strategic digital consulting, PMO leadership, or career mentorship through our PM Launchpad program, we're here to elevate your success.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-5 justify-center">
          <Link
            to="/book-consultation"
            className="inline-flex items-center justify-center bg-warm-gold text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-soft-bronze transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Schedule a Consultation
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center border-2 border-charcoal text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-charcoal hover:text-warm-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Explore PM Launchpad
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

export default CTASection;
